import { Avatar, Button, CircularProgress, Divider, Grid } from '@material-ui/core';
import React from 'react';
import CustomAppBar from '../../commons/AppBar';
import SpecificComponent from '../../commons/SpecificComponent';
import LocalStorage from '../../providers/LocalStorage';
import Masks from '../../providers/Masks';
import Utils from '../../providers/Utils';
import Ws from '../../providers/Ws';
import WsC from '../chestionare/providers/WsC';
import avatar from '../../Pics/avatar.jpg'
import FileIcon from '../../providers/FileIcon';
import AlertNew from '../../commons/dialogs/AlertNew';
import AddAplicatieNoua from './AddAplicatieNoua';
import generic from '../../Pics/iconsMonitorizare/generic.png'


export default class MonitorizareDaily extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            dataAzi: this.u.defaultData(),
            dataStart: this.m.fistDayMonth(new Date()),
            dataEnd: this.m.lastDayMonth(new Date()),
            departamente: [],
            departament: -1,
            angajati: [],
            aplicatiiProductive: [],
            aplicatiiNeproductive: [],
            loading: true,
            alertView: false,
            openAplicatieNoua: false,
            openAplicatieEdit: false,
            newApp: { hash_id: '', is_productive: -1, nume: 'New App', process_name: ' ', process_name_x86: ' ' },

        }
    }

    componentDidMount() {
        this.access()
        this.updateUserListAndGetAngajati()
    }

    access = async () => {



        console.log('this.ls.InfoUser.IsAdmin :>> ', this.ls.InfoUser.IsAdmin);

        if (this.ls.InfoUser.IsAdmin !== 1) {


            this.setState({ alertView: this.ls.InfoUser.EsteSef === 1 ? false : true })
        }


    }

    ws = new Ws();
    u = new Utils();
    m = new Masks();
    wsC = new WsC();
    ls = new LocalStorage().GetUserData()



    updateUserListAndGetAngajati = async (depart = null) => {

        // let getData = await this.ws.getData('Monitorizare/UpdateAppsList')

        // console.log('getData :>> ', getData);

        // if (getData.Succes) {

        let _angajati = this.ws.customSelect(`select a.*, ad.id_departament from angajati a left join angajati_departamente ad
                                            on a.id = ad.id_angajat where a.data_angajarii <= '${this.state.dataEnd}' and isnull(a.data_plecarii , '2999-01-01') > '${this.state.dataStart}' and isnull(a.inactiv,0) != 1 `, {
            p1: this.state.dataEnd,
            p2: this.state.dataStart
        })

        let _departamente = this.ws.customSelect(`select * from departamente where isnull(inactiv,0) != 1`, {
            p1: 1
        })


        let _concedii = this.ws.customSelect(`select c.*, p.id_angajat from concedii c left outer join pontaje p on p.id_concediu = c.id
        where year(c.cand_inceput_data) = year(@p1) OR year(c.cand_sfarsit_data) = year(@p1) and isnull(p.sters,0) != 1 ` , {
            p1: this.state.dataStart,
            p2: this.state.dataEnd
        })
        // let _concedii = this.ws.customSelect('select * from concedii where 1 = @p1',{p1:1})

        let _pontaje = this.ws.customSelect(`select * from pontaje where year(la_data) = year(@p1) and isnull(sters,0) != 1`, {
            p1: this.state.dataStart
        })


        let _monitorAngajati = this.ws.customSelect(`select * from monitorizare_log_folosire
            where Cast(start_datetime as date) = @p1`, {
            p1: this.state.dataAzi
        })

        let _monitorAngajatiStatus = this.ws.customSelect(`select * from monitorizare_log_folosire where cand_received between DATEADD(minute, -15, getdate()) and getdate() order by cand_received desc`, {
            p1: this.state.dataAzi
        })


        let [angajati, departamente, concedii, pontaje, monitorAngajati, monitorStatus] = await Promise.all([_angajati, _departamente, _concedii, _pontaje, _monitorAngajati, _monitorAngajatiStatus])

        if (angajati.Succes && departamente.Succes && concedii.Succes && pontaje.Succes && monitorAngajati.Succes) {

        //     let _evaluari = this.wsC.customSelect(`select e.*, a.poza, a.id as id_angajat, a.functie, a.nume as nume_user, (select count(*) from raspunsuri_head where id_evaluare = e.id and statusul = @p1) as completari_finalizate, 
        //         (select count(*) from raspunsuri_head where id_evaluare = e.id ) as completari_toate, s.nume
        // from evaluari e left join [${this.ls.InfoUser.Database}].[dbo].[angajati] a on a.id_user = e.id_user_aprobare
        // left join sesiuni s on s.id = e.id_sesiune
        // where s.baza_date = @p2 and isnull(e.inactiv,0) != 1  ` , {
        //         p1: 'Finalizat',
        //         p2: this.ls.InfoUser.Database
        //     })




        //     let _optiuniRaspuns = this.wsC.customSelect(`select r.*, h.id_evaluare, h.statusul from raspunsuri_intrebari_raspunsuri r left join raspunsuri_head h on r.id_head = h.id 
        //     order by r.id_optiune_raspuns asc`, {
        //         p1: this.props.match.params.idsesiune,

        //     })

            let aplicatiiAll = await this.ws.customSelect(`select * from monitorizare_aplicatii where isnull(sters,0) != 1`, {
                p1: 1
            })





            // let [evalu, optiuniRaspuns, aplicatiiAll] = await Promise.all([_evaluari, _optiuniRaspuns, _aplicatiiAll])
       
            // console.log('evalu :>> ', evalu);
          

            if ( aplicatiiAll.Succes) {

                console.log('aplicatiiAll :>> ', aplicatiiAll);

                        let ang = [...angajati.Content]
                        let dep = [...departamente.Content]
                        let pont = [...pontaje.Content]
                        let conc = [...concedii.Content]
                        // let optiuniR = [...optiuniRaspuns.Content]
                        let monitor = [...monitorAngajati.Content]
                        let appAll = [...aplicatiiAll.Content]

                        let mon = [...monitorAngajati.Content]

                        // let evaluari = [...evalu.Content]

                        console.log('pont :>> ', pont);
                        console.log('conc :>> ', conc);
                        console.log('monitorAngajati :>> ', monitorAngajati);
                        console.log('aplicatiiAll :>> ', aplicatiiAll);


                        let punctajMaxim = 0

                        // punctajMaxim = optiuniR.reduce((a, r) => { return a + (r.puncte || 0) }, 0)

                        // punctajMaxim = punctajMaxim / evaluari.length

                        // for (let j = 0, m = evaluari.length; j < m; j++) {
                        //     let pct = 0



                        //     // console.log('punctajMaxim :>> ', punctajMaxim);

                        //     // console.log('evaluari[j] :>> ', evaluari[j]);


                        //     let filterR = optiuniR.filter(o => o.id_evaluare === evaluari[j].id)

                        //     if (filterR.length > 0) {
                        //         for (let k = 0, l = filterR.length; k < l; k++) {


                        //             pct += filterR[k].raspuns ? filterR[k].puncte : 0 || 0
                        //         }

                        //         evaluari[j].puncte = pct
                        //     } else {
                        //         evaluari[j].puncte = pct
                        //     }

                        //     evaluari[j].procent_completare = Math.floor(((evaluari[j].completari_finalizate * 100) / evaluari[j].completari_toate) || 0)

                        //     evaluari[j].color = evaluari[j].procent_completare >= 80 ? 'rgb(24 165 58)' : (evaluari[j].procent_completare < 80 && evaluari[j].procent_completare >= 50 ? 'rgb(227 154 10)' : 'rgb(252,93,98)')
                        //     evaluari[j].color_puncte = evaluari[j].puncte >= (punctajMaxim - (punctajMaxim / 3)) ? 'rgb(24 165 58)' : (evaluari[j].puncte < (punctajMaxim - (punctajMaxim / 3)) && evaluari[j].puncte >= (punctajMaxim / 2) ? 'rgb(227 154 10)' : 'rgb(252,93,98)')
                        //     evaluari[j].checked = false
                        //     evaluari[j].raspunsuri = filterR



                        // }

                        for (let i = 0, n = ang.length; i < n; i++) {
                            let idxDep = dep.findIndex(d => Number(d.id) === Number(ang[i].id_departament))



                            if (idxDep !== -1) {

                                ang[i]['nume_departament'] = dep[idxDep].nume
                            }


                            let idxPontaje = pont.findIndex(pp => Number(pp.id_angajat) === Number(ang[i].id) && this.m.datesAreEgual(new Date(pp.la_data), new Date(this.state.dataAzi)))

                            console.log('idxPontaje :>> ', idxPontaje);

                            if (idxPontaje !== -1) {

                                if (pont[idxPontaje].prezent_azi === 1) {
                                    ang[i]['status_concediu'] = 'Activ'
                                } else if (pont[idxPontaje].absent_azi === 1) {
                                    ang[i]['status_concediu'] = 'Absent'
                                } else {
                                    ang[i]['status_concediu'] = 'Activ'
                                }


                            } else {
                                let idxConcedii = conc.findIndex(cc => cc.id_angajat === ang[i].id &&
                                    (this.u.compareDate(this.state.dataAzi, cc.cand_inceput_data) && this.u.compareDate(cc.cand_sfarsit_data, this.state.dataAzi)) === true)

                                if (idxConcedii !== -1) {
                                    console.log('conc[idxConcedii] :>> ', conc[idxConcedii]);

                                    let idxLabelConcedii = this.u.tipConcedii.findIndex(cc => cc.id === conc[idxConcedii].tip_concediu)

                                    if (idxLabelConcedii !== -1) {

                                        ang[i]['status_concediu'] = this.u.tipConcedii[idxLabelConcedii].nume.length > 10 ? this.u.tipConcedii[idxLabelConcedii].nume.substring(0, 9) + '...' : this.u.tipConcedii[idxLabelConcedii].nume
                                    }
                                }


                            }


                            // let filterEvaluari = evaluari.filter(ee => Number(ee.id_angajat) === Number(ang[i].id))

                            // if (filterEvaluari.length > 0) {

                            //     console.log('filterEvaluari :>> ', filterEvaluari);
                            //     ang[i].puncte = filterEvaluari.reduce((a, c) => {
                            //         console.log('a :>> ', a);
                            //         console.log('c.puncte :>> ', c.puncte);
                            //         return a + c.puncte
                            //     }, 0)
                            // }

                            let filterMonitorizare = mon.filter(mo => mo.id_user === ang[i].id)

                            console.log('filterMonitorizare :>> ', filterMonitorizare);
        
        
                            if (filterMonitorizare.length > 0) {
                                ang[i]['last_date_received'] = filterMonitorizare[0]['cand_received']
                                ang[i]['status_live'] = true
                            } else {
                                let monAllDayF = monitor.filter(mo => mo.id_user === ang[i].id)
        
                                ang[i]['last_date_received'] = monAllDayF.length > 0 ? monAllDayF[0]['cand_received'] : null
                                ang[i]['inactive_all_day'] = this.dictionary.pontaje.inactivAzi
                                ang[i]['status_live'] = false
                            }


                            ang[i]['app_productive_time'] =  mon.filter(app => app.is_productive === 1 && app.id_user === ang[i].id && app.app_id !== "i0000000000000000000000000000000").reduce((a, c) => {
                                return a + c.seconds_used
                            }, 0)

                            ang[i]['app_productive_time'] = this.u.secondsToHoursAndMinutes(ang[i]['app_productive_time'])




                        }

                        console.log('mon :>> ', mon);

                        let aplicatiiProductive = appAll.filter(app => app.is_productive === 1)
                        let aplicatiiNeproductive = appAll.filter(app => app.is_productive !== 1)


                        ang = this.u.filterMonitorizareAngajati(ang, appAll, monitor)

                        console.log('ang :>> ', ang);

                        console.log('dep :>> ', dep);

                        if (depart) {
                            ang = ang.filter(aa => Number(aa.id_departament) === Number(depart))
                        }


                        let newApp = { ...this.state.newApp }

                        if (newApp.hash_id.length > 0) {

                            let idx = appAll.findIndex(apps => apps.hash_id === newApp.hash_id)



                            if (idx !== -1) {
                                newApp.icon = appAll[idx]['icon']
                            }



                        }

                        this.setState({
                            angajati: ang,
                            newApp: newApp,
                            departamente: dep,
                            departament: depart || -1,
                            aplicatiiProductive: aplicatiiProductive,
                            aplicatiiNeproductive: aplicatiiNeproductive,
                            loading: false
                        })

                    
            }
        }


    }


    changeDepartament = async (ev) => {

        let val = ev.target.value
        this.setState({ departament: val }, async () => {

            if (Number(val) === -1) {
                this.setState({ loading: true }, () => {

                    this.updateUserListAndGetAngajati()
                })
            } else {
                this.setState({ loading: true }, () => {

                    this.updateUserListAndGetAngajati(val)
                })
            }

        })
    }




    minusZi = () => {

        let dataStart = this.state.dataAzi




        dataStart = new Date(dataStart).setDate(new Date(dataStart).getDate() - 1)
        dataStart = new Date(dataStart)

        console.log('dataStart :>> ', dataStart);

        if (dataStart.getMonth() < new Date(this.state.dataAzi).getMonth()) {
            let dataS = this.m.fistDayMonth(dataStart)
            let dataE = this.m.lastDayMonth(dataStart)

            this.setState({
                dataAzi: this.u.transformDataForSql(dataStart),
                dataStart: dataS,
                dataEnd: dataE,
                loading: true
            }, () => {


                this.updateUserListAndGetAngajati()

            })
        } else {
            this.setState({
                dataAzi: this.u.transformDataForSql(dataStart),
                loading: true

            }, () => {


                this.updateUserListAndGetAngajati()

            })
        }


    }


    plusZi = () => {
        let dataEnd = this.state.dataAzi




        dataEnd = new Date(dataEnd).setDate(new Date(dataEnd).getDate() + 1)
        dataEnd = new Date(dataEnd)

        console.log('dataEnd :>> ', dataEnd);

        if (dataEnd.getMonth() > new Date(this.state.dataAzi).getMonth()) {
            let dataS = this.m.fistDayMonth(dataEnd)
            let dataE = this.m.lastDayMonth(dataEnd)

            this.setState({
                dataAzi: this.u.transformDataForSql(dataEnd),
                dataStart: dataS,
                dataEnd: dataE,
                loading: true
            }, () => {
                this.updateUserListAndGetAngajati()
            })
        } else {
            this.setState({
                dataAzi: this.u.transformDataForSql(dataEnd),
                loading: true

            }, () => {
                this.updateUserListAndGetAngajati()
            })
        }
    }




    numeLuna = (l) => {

        // console.log('l :', l);
        let rez = ''

        switch (l) {
            case 1: rez = this.dictionary.luni.ianuarie; break;
            case 2: rez = this.dictionary.luni.februarie; break;
            case 3: rez = this.dictionary.luni.martie; break;
            case 4: rez = this.dictionary.luni.aprilie; break;
            case 5: rez = this.dictionary.luni.mai; break;
            case 6: rez = this.dictionary.luni.iunie; break;
            case 7: rez = this.dictionary.luni.iulie; break;
            case 8: rez = this.dictionary.luni.august; break;
            case 9: rez = this.dictionary.luni.septembrie; break;
            case 10: rez = this.dictionary.luni.octombrie; break;
            case 11: rez = this.dictionary.luni.noiembrie; break;
            case 12: rez = this.dictionary.luni.decembrie; break;

        }

        return rez
    }


    numeAvatar = (nume) => {

        if (nume) {
            let n = nume.split(' ')

            // console.log('n :>> ', n);

            let firstLetters = ''

            if (n[0]) {

                firstLetters += n[0].substring(0, 1)

            }
            if (n[1]) {
                firstLetters += n[1].substring(0, 1)
            }

            firstLetters = firstLetters.toUpperCase()

            return firstLetters
        } else {
            return 'NA'
        }


    }

    changeAplicatie = (ev) => {

        let n = ev.target.name
        let v = ev.target.value

        let app = { ...this.state.newApp }

        app[n] = v

        this.setState({ newApp: app })
    }



    openNewApp = async (isProductive) => {

        let newApp = { ...this.state.newApp }

        newApp['is_productive'] = isProductive



        newApp['hash_id'] = this.u.randomData(32)

        console.log('newApp :>> ', newApp);


        let insertApp = await this.ws.insert('monitorizare_aplicatii', newApp)

        if (insertApp.Succes) {
            // this.setState({openAplicatieNoua:false,
            //     newApp: { hash_id: '', is_productive: -1, nume: 'New App', process_name: '', process_name_x86: '' } },()=>{
            //         this.updateUserListAndGetAngajati()
            //     })

            newApp['id'] = insertApp.Content[0].id
            this.setState({
                newApp: newApp,
                openAplicatieNoua: true
            })
        }
    }






    openEditApp = (a) => {

        console.log('a :>> ', a);

        this.setState({
            newApp: a,
            openAplicatieEdit: true
        })
    }


    // insertApp = async () => {


    //     let newApp = { ...this.state.newApp }

    //     newApp['hash_id'] = this.u.randomData(32)

    //     console.log('newApp :>> ', newApp);


    //     let insertApp = await this.ws.insert('monitorizare_aplicatii', newApp)

    //     if(insertApp.Succes){
    //         // this.setState({openAplicatieNoua:false,
    //         //     newApp: { hash_id: '', is_productive: -1, nume: 'New App', process_name: '', process_name_x86: '' } },()=>{
    //         //         this.updateUserListAndGetAngajati()
    //         //     })

    //         this.setState({
    //             newApp: newApp,
    //             openAplicatieNoua: true
    //         })
    //     }


    // }


    editApp = async () => {

        let newApp = {
            is_productive: this.state.newApp.is_productive || 0,
            nume: this.state.newApp.nume || '',
            process_name: this.state.newApp.process_name || '',
            process_name_x86: this.state.newApp.process_name_x86 || ''
        }

        console.log('newApp :>> ', newApp);
        let editApp = await this.ws.update('monitorizare_aplicatii', newApp, { id: this.state.newApp.id })

        if (editApp.Succes) {
            this.setState({
                openAplicatieEdit: false,
                openAplicatieNoua: false,
                newApp: { hash_id: '', is_productive: -1, nume: 'New App', process_name: '', process_name_x86: '' }
            }, () => {
                this.updateUserListAndGetAngajati()
            })
        }

        console.log('newApp :>> ', newApp);
    }

    deleteApp = async() =>{

        console.log('app :>> ', this.state.newApp);
        let deleteApp = await this.ws.update('monitorizare_aplicatii', {sters:1}, { id: this.state.newApp.id })

        if(deleteApp.Succes){
            this.setState({
                openAplicatieEdit: false,
                openAplicatieNoua: false,
                newApp: { hash_id: '', is_productive: -1, nume: 'New App', process_name: '', process_name_x86: '' }
            }, () => {
                this.updateUserListAndGetAngajati()
            })
        }
    }

    render() {
        return (
            <div>

                <CustomAppBar history={this.props.history} title={' '} />

                <AlertNew
                    open={this.state.alertView}
                    dialogClose={() => { this.setState({ alertView: false }) }}
                    title={this.dictionary.proiecte.alertView}
                    mesaj={this.dictionary.proiecte.alertViewMessage}
                    noButtonDisplay={1}
                    yesFunction={() => { this.props.history.replace('/') }}
                    fullScreen={true}
                />


                <AddAplicatieNoua
                    open={this.state.openAplicatieNoua}
                    dialogClose={() => {
                        this.setState({
                            openAplicatieNoua: false,
                            newApp: { hash_id: '', is_productive: -1, nume: 'New App', process_name: '', process_name_x86: '' }
                        })
                    }}
                    aplicatie={this.state.newApp}
                    changeAplicatie={this.changeAplicatie}
                    salveazaAplicatie={this.editApp}
                    getData={this.updateUserListAndGetAngajati}
                    deleteApp={this.deleteApp}
                />

                <AddAplicatieNoua
                    open={this.state.openAplicatieEdit}
                    dialogClose={() => {
                        this.setState({
                            openAplicatieEdit: false,
                            newApp: { hash_id: '', is_productive: -1, nume: 'New App', process_name: '', process_name_x86: '' }
                        })
                    }}
                    aplicatie={this.state.newApp}
                    changeAplicatie={this.changeAplicatie}
                    salveazaAplicatie={this.editApp}
                    getData={this.updateUserListAndGetAngajati}
                    deleteApp={this.deleteApp}
                />

                {this.state.loading &&
                    <div className='loading-div' >

                        <CircularProgress
                            style={{
                                width: 60,
                                height: 60,
                                color: '#25e048',
                                marginTop: '40%'
                            }}
                            value={20}

                        />
                        <span style={{ display: 'block', fontSize: 20 }}>Loading...</span>
                    </div>
                }

                <Grid style={{ maxWidth: 1300, margin: 'auto', marginBottom: 40 }} container >
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <h1 style={{ margin: '80px 0 40px 0' }} className='pm-title-big'>{this.dictionary.monitorizare.monitorizareAngajati} </h1>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40, maxHeight: 600, overflow: 'scroll' }}>



                            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                                <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLeft: 20, paddingTop: 10 }} > {this.dictionary.monitorizare.lucratori}</h5>
                            </Grid>



                            <Grid style={{ textAlign: 'right' }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                <div style={{ marginTop: 20, textAlign: 'right' }} className='monthcalendar-header'>
                                    <i onClick={this.minusZi} className='material-icons' style={{ verticalAlign: 'sub', cursor: 'pointer', fontSize: 20 }}>keyboard_arrow_left</i>
                                    <span style={{ fontSize: 16, verticalAlign: 'text-bottom', textTransform: 'uppercase' }} className='monthcalendar-title'>
                                        {new Date(this.state.dataAzi).getDate() < 10 ? '0' + new Date(this.state.dataAzi).getDate() : new Date(this.state.dataAzi).getDate()} {this.numeLuna(new Date(this.state.dataStart).getMonth() + 1)} {new Date(this.state.dataStart).getFullYear()}

                                    </span>
                                    <i onClick={this.plusZi} className='material-icons' style={{ verticalAlign: 'sub', cursor: 'pointer', fontSize: 20 }}>keyboard_arrow_right</i>
                                </div>
                            </Grid>


                            <Grid style={{ textAlign: 'left', margin: '20px 0 20px 0' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40, overflow: 'scroll' }}>



                                    <Grid style={{ paddingTop: 5 }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                        <div style={{ position: 'relative' }}>
                                            <select
                                                id='departament'
                                                style={{ width: '90%', paddingTop: 9, paddingBottom: 9 }}
                                                className='add-project-input'
                                                type="text"
                                                margin="normal"
                                                name='tva'
                                                // disabled={this.state.departamentDisabled !== 1 ? true : false}
                                                value={this.state.departament || ""}
                                                onChange={(ev) => { this.changeDepartament(ev) }}
                                                placeholder={this.dictionary.pontaje.departamentCautaLucrator}
                                            >

                                                <option value={-1}>{this.dictionary.pontaje.toate}</option>
                                                {this.state.departamente.map((s, idx) => {
                                                    return (
                                                        <option key={idx} value={s.id}>{s.nume}</option>
                                                    )
                                                })}
                                            </select>
                                            {/* <label className='inputLabelPM' htmlFor='tipCost'>{this.dictionary.evaluari.selecteaza}</label> */}
                                        </div>

                                    </Grid>
                                    <Grid style={{ textAlign: 'center', paddingTop: 15 }} item xs={2} sm={2} md={2} lg={2} xl={2}>


                                        <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.monitorizare.statut}</span>

                                    </Grid>

                                    <Grid style={{ textAlign: 'center', paddingTop: 15 }} item xs={3} sm={3} md={3} lg={3} xl={3}>

                                        <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.monitorizare.timpProductiv}</span>


                                    </Grid>
                                    <Grid style={{ textAlign: 'left', paddingTop: 15 }} item xs={4} sm={4} md={4} lg={4} xl={4}>

                                        <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.monitorizare.celeMaiFolosite}</span>


                                    </Grid>




                                </Grid>



                                <Divider style={{ marginTop: 20, marginBottom: 20 }} className="pm-divider" />


                                {this.state.angajati.map((a, idx) => {

                                    return (

                                        <Grid onClick={() => { this.props.history.push(`/monitorizareangajat/${a.id}`) }} style={{ marginBottom: 20 }} key={idx} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <Grid container>

                                                <Grid style={{ paddingTop: 5 }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                    <Grid container>

                                                        <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                            {
                                                                a.poza &&
                                                                <div
                                                                    className='pm-angajati-picture'

                                                                    style={{ backgroundImage: `url('${a.poza ? (new Ws().adresaMedia + '/Angajati/' + a.poza) : avatar}')`, width: 36, height: 36, padding: 5 }}>

                                                                </div>
                                                            }
                                                            {!a.poza &&

                                                                <Avatar
                                                                    className='pm-angajati-picture'
                                                                    style={{ display: 'inline-block', textAlign: 'center', height: 24, width: 24, backgroundColor: new Utils().culoriUtilizatori(a.id), padding: 5, cursor: 'pointer' }}>
                                                                    {/* <i style={{ verticalAlign: '-webkit-baseline-middle', cursor: 'pointer' }} className='material-icons'>person</i> */}
                                                                    <span style={{ display: 'block' }}>{this.numeAvatar(a.nume)} </span>
                                                                </Avatar>
                                                                // <Avatar onClick={this.props.userClick} style={{ display: 'inline-flex' }} className='pm-avatar'> {this.getLitereAvatar(u.nume + ' ')} </Avatar>
                                                            }
                                                        </Grid>

                                                        <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>
                                                            <span style={{ fontWeight: 500, fontSize: 14 }}>    {a.nume}</span><br />
                                                            <span style={{
                                                                fontSize: 12,
                                                                color: '#9a9a9a'
                                                            }}>{a.functie}</span>
                                                        </Grid>

                                                    </Grid>

                                                </Grid>
                                                <Grid style={{ textAlign: 'center', paddingTop: 15 }} item xs={2} sm={2} md={2} lg={2} xl={2}>


                                                <div style={{
                                                            width: 20,
                                                            height: 20,
                                                            borderRadius: '50%',
                                                            backgroundColor: a['status_live'] ? 'rgb(24	165	58)' : 'rgb(252	93	98)',
                                                            margin:'auto'
                                                        }}>

                                                        </div>

                                                </Grid>

                                                <Grid style={{ textAlign: 'center', paddingTop: 15 }} item xs={3} sm={3} md={3} lg={3} xl={3}>

                                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.monitorizare.timpProductiv}</span>
                                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{a.app_productive_time || 0}</span>


                                                </Grid>
                                                <Grid style={{ textAlign: 'left', paddingTop: 15 }} item xs={4} sm={4} md={4} lg={4} xl={4}>

                                                    {a.aplicatii.map((app, idx2) => {

                                                        if (app.secunde > 0) {

                                                            return (
                                                                <div
                                                                    style={{ display: 'inline-block', marginRight: 20 }}
                                                                    key={`app${idx2}`}>
                                                                    <img

                                                                        style={{ margin: 0, width: 30, height: 30 }}
                                                                        src={app.icon ? `${this.ws.adresaMedia}/monitorizare/icons/${app.icon}` : generic}
                                                                    />


                                                                </div>
                                                            )


                                                        }

                                                    })}


                                                </Grid>





                                            </Grid>

                                        </Grid>
                                    )


                                })}
                            </Grid>


                        </Grid>


                    </Grid>


                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Grid container>

                            <Grid style={{ paddingRight: 10 }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40, maxHeight: 600, overflow: 'scroll', height: '100%' }}>




                                    <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>

                                        <Grid container>
                                            <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
                                                <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} > {this.dictionary.monitorizare.appProductivitate}</h5>
                                            </Grid>

                                            <Grid style={{ paddingTop: 14 }} item xs={4} sm={4} md={4} lg={4} xl={4}>
                                                <Button
                                                    style={{ width: '100%' }}

                                                    className={'add-button-blue'} onClick={() => { this.openNewApp(1) }}  >

                                                    {this.dictionary.monitorizare.adaugaAplicatie}
                                                </Button>

                                            </Grid>
                                            <Divider style={{ marginTop: 20, marginBottom: 20 }} className="pm-divider" />
                                        </Grid>


                                        {this.state.aplicatiiProductive.map((app, idx) => {

                                            return (
                                                <div onClick={() => { this.openEditApp(app) }} style={{ marginBottom: 20, cursor:'pointer' }} key={idx}>

                                                    <div
                                                        style={{ display: 'inline-block', marginRight: 20, verticalAlign: 'middle' }}
                                                    >
                                                        <img

                                                            style={{ margin: 0, width: 30, height: 30 }}
                                                            src={app.icon ? `${this.ws.adresaMedia}/monitorizare/icons/${app.icon}` : generic}
                                                        />

                                                    </div>

                                                    <span style={{ fontWeight: 500, fontSize: 14 }}>    {app.nume}</span><br />

                                                </div>
                                            )

                                        })}

                                    </Grid>

                                </Grid>


                            </Grid>

                            <Grid style={{ paddingLeft: 10 }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40, maxHeight: 600, overflow: 'scroll', height: '100%' }}>




                                    <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>


                                        <Grid container>
                                            <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
                                                <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} > {this.dictionary.monitorizare.appNeproductivitate}</h5>
                                            </Grid>

                                            <Grid style={{ paddingTop: 14 }} item xs={4} sm={4} md={4} lg={4} xl={4}>
                                                <Button
                                                    style={{ width: '100%' }}

                                                    className={'add-button-blue'} onClick={() => { this.openNewApp(0) }}  >

                                                    {this.dictionary.monitorizare.adaugaAplicatie}
                                                </Button>

                                            </Grid>
                                            <Divider style={{ marginTop: 20, marginBottom: 20 }} className="pm-divider" />
                                        </Grid>


                                        {this.state.aplicatiiNeproductive.map((app, idx) => {

                                            return (
                                                <div onClick={() => { this.openEditApp(app) }} style={{ marginBottom: 20, cursor:'pointer'  }} key={idx}>

                                                    <div
                                                        style={{ display: 'inline-block', marginRight: 20, verticalAlign: 'middle' }}
                                                    >
                                                        <img

                                                            style={{ margin: 0, width: 30, height: 30 }}
                                                            src={app.icon ? `${this.ws.adresaMedia}/monitorizare/icons/${app.icon}` : generic}
                                                        />

                                                    </div>

                                                    <span style={{ fontWeight: 500, fontSize: 14 }}>    {app.nume}</span><br />

                                                </div>
                                            )

                                        })}

                                    </Grid>

                                </Grid>


                            </Grid>

                        </Grid>
                    </Grid>







                </Grid>
            </div>
        );
    }
}